import React from "react";
import "../styles/body.scss";

export default function Body({
  children,
  topRight,
  topMiddle,
  topLeft,
  contentStyle,
  back,
  title,
  bodyStyle,
  onBack,
  noTopSection,
  noPadding,
}) {
  return (
    <div className="body" style={{ ...bodyStyle, padding: noPadding ? 0 : 30 }}>
      {!noTopSection && (
        <div className="top-section">
          <div className="left">{topLeft}</div>
          <div className="middle">
            {title && <div className="title text-center">{title}</div>}
            {topMiddle}
          </div>
          <div className="right">{topRight}</div>
        </div>
      )}
      <div className="content">
        <div style={{ width: "100%", ...contentStyle }}>
          <div
            style={{
              justifyContent: "center",
              display: "flex",
            }}
          >
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}
